module.exports = __webpack_public_path__ + "static/media/brios-frutas-b.cc3a1c9f.webp";